export default __webpack_public_path__ + "static/media/yeopen_cube@2x.68488351.jpg";